export default __webpack_public_path__ + "static/media/tavi_mobile_small@2x.5611457e.jpg";